import * as React from "react";
import { forwardRef, memo } from "react";
const SvgRemove = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("mask", { id: "mask0_583_39873", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24 })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_583_39873)" }, /* @__PURE__ */ React.createElement("path", { d: "M5 13V11H19V13H5Z" })));
const ForwardRef = forwardRef(SvgRemove);
const Memo = memo(ForwardRef);
export { Memo as ReactComponent };
